import { notifyError } from 'src/common/components/Toast';
import { ProcessStatusDTO } from 'src/common/models/processModels';
import { VerificationStatus } from 'src/common/models/verificationModels';
import {
  getRedirectUrlForProcess,
  getRedirectUrlForStatus,
  handleRedirect,
} from 'src/common/services/process';
import { verificationQueryKeys } from 'src/common/verificationQueryKeys';
import { queryClient } from 'src/config/ReactQueryClientProvider';
import { verificationIdParam } from 'src/routes';
import { environment } from '../../config/environment';

export enum ErrorCode {
  BankAlreadySelected = 'MC.ASPSPS_ALREADY_SELECTED',
  VerificationNotFound = 'MC.VERIFICATION_NOT_FOUND',
  WrongState = 'MC.VERIFICATION_IN_WRONG_STATE',
  InvalidRequest = 'MC.MC_CONSENTS_AUTH_HTTP_RESPONSE_ERROR',
  Unknown = 'unknown',
  UnexpectedRequest = 'unexpected',
  Internal = 'internal',
  StateNotFound = 'MC.MC_STATE_NOT_FOUND',
  ConsentAuthError = 'MC.MC_CONSENTS_AUTH_HTTP_RESPONSE_ERROR',
  AuthTokenError = 'AIIA.AUTHENTICATE_TOKEN_ERROR',
}

export const errorMsgs: Record<ErrorCode | string, string> = {
  [ErrorCode.Internal]: 'Wystąpił błąd wewnętrzny',
  [ErrorCode.BankAlreadySelected]: 'Bank dla danego procesu został już wybrany',
  [ErrorCode.VerificationNotFound]: 'Id dla procesu nie znalezione',
  [ErrorCode.Unknown]: 'Przepraszamy, wystąpił błąd',
  [ErrorCode.WrongState]:
    'Przepraszamy, ta weryfikacja nie jest aktywna. Spróbuj ponownie rozpocząć proces.',
  [ErrorCode.InvalidRequest]:
    ' Przepraszamy, ta weryfikacja nie jest aktywna. Spróbuj ponownie rozpocząć proces.',
  [ErrorCode.UnexpectedRequest]: 'Wystąpił nieznany błąd połączenia',
  [ErrorCode.StateNotFound]: 'Nieudana próba logowania',
  [ErrorCode.ConsentAuthError]: 'Nieudana próba logowania',
  [ErrorCode.AuthTokenError]: 'Nieudana próba logowania',
};

const getVerificationId = () => {
  const search = new URLSearchParams(window.location.search);

  return (
    search.get(verificationIdParam) || localStorage.getItem(verificationIdParam)
  );
};

export const handleRedirectError = (error: unknown) => {
  notifyError(error, 'Rozpocznij od nowa');
};

export const toErrorResponse = (
  error: unknown,
  verificationStatus?: VerificationStatus
) => {
  const verificationId = getVerificationId();

  if (!verificationId) {
    notifyError(error, 'Rozpocznij od nowa');
    return error;
  }

  const status =
    verificationStatus ??
    queryClient.getQueryData<ProcessStatusDTO>(
      verificationQueryKeys.status(verificationId)
    )?.verificationStatus;

  queryClient
    .fetchQuery({
      queryKey: verificationQueryKeys.redirect(verificationId),
      queryFn: () => getRedirectUrlForProcess(verificationId),
    })
    .then(({ redirectUrl, failedRedirectUrl }) => {
      const url = getRedirectUrlForStatus(status, {
        redirectUrl,
        failedRedirectUrl,
      });

      if (environment.appTenant === 'wFirma') {
        notifyError(error, 'Wróć do procesu partnera', `${url}/1`);
        return;
      }

      if (environment.appTenant !== 'ais') {
        notifyError(error, 'Wróć do procesu partnera', url);
      }

      if (environment.appTenant === 'ais') {
        notifyError(error, 'Wróć do procesu', url);
        setTimeout(() => {
          handleRedirect(url);
        }, 5000);
      }
    })
    .catch(handleRedirectError);

  return error;
};
